import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0d2d6594&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {Footer: require('/lasso/components/Footer.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d2d6594')) {
      api.createRecord('0d2d6594', component.options)
    } else {
      api.reload('0d2d6594', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=0d2d6594&", function () {
      api.rerender('0d2d6594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Footer.vue"
export default component.exports